import React, { useEffect } from "react";
import { Form, DatePicker } from "antd";
import dayjs from "dayjs";
function Range({
  form,
  minDate,
  controlHeight,
  maxDate,
  name,
  label,
  placeholder,
  width,
  labelCol,
  errorMessage,
  validateFunction,
  defaultValue,
  disabled,
  required,
  format,
  isIST,
  bg = '#ffffff'
}) {
  // console.log(defaultValue[0]);

  useEffect(() => {
    if(defaultValue && form){
      form.setFieldsValue({ [name]: [
       dayjs(defaultValue[0]),
       dayjs(defaultValue[1]),
      ]})
    }
  }, []);

  return (
    <Form.Item
      name={name}
      label={label}
      labelCol={{span: labelCol ? labelCol : 8}}
      initialValue={!form && [
        defaultValue ? dayjs(defaultValue[0]) : "",
        defaultValue ? dayjs(defaultValue[1]) : "",
      ]}
      placeholder={placeholder}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        { required: required, message: errorMessage },
        () => ({
          validator(rule, value) {
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      <DatePicker.RangePicker
        minDate={minDate ? dayjs(minDate, "YYYY-MM-DD") : undefined}
        maxDate={maxDate ? dayjs(maxDate, "YYYY-MM-DD") : undefined}
        disabled={disabled}
        showTime={false}
        style={{ backgroundColor: bg, fontWeight: 600, minHeight: controlHeight || 40 }}
        use12Hours={isIST ? isIST : false}
        format={format ? format : "YYYY-MM-DD hh:mm:ss"}
        className="gx-mb-3 gx-w-100"
        placeholder={["Start Date", "End Date"]}
      />
    </Form.Item>
  );
}

export default Range;
